<template>
	<div class="detail-main">
		<NavMenu />
		<div class="detail-body">
			<div class="detail-body-header">
				<div class="detail-body-header-left">
					<div class="detail-body-header-left-main">
						<img class="detail-body-header-left-main-img" :src="content.logo_path" />
						<div class="detail-body-header-left-main-content">
							<div class="detail-body-header-left-main-content-title">
								<div class="p1">{{content.display_name}}</div>
								<div class="p2">{{content.description}}</div>
							</div>
							<div class="detail-body-header-left-main-content-btn"
								@click="goWebsite(content.website_url)">
								<div class="detail-body-header-left-main-content-btn-foot">打开网站 </div><img
									class="detail-body-header-left-main-content-btn-foot-img" src="../assets/you.png" />
							</div>
							<div class="detail-body-header-left-main-content-foot">收录时间：{{content.inclusion_time}}</div>
						</div>
					</div>
					<div class="detail-body-header-left-main-hr"></div>
					<div class="detail-body-header-left-main-foot">{{content.full_description}}</div>
				</div>
				<div class="detail-body-header-right" @click="goLink()">
					<div class="detail-body-header-right-title">
						<div class="detail-body-header-right-title-font">免费90天SCI 速成，导师带队！</div>
					</div>
					<div class="detail-body-header-right-content">
						<div class="detail-body-header-right-content-model">
							<!-- 	<img
								:src="`https://s0.wp.com/mshots/v1/${encodeURIComponent(content.website_url)}?w=376&h=250`" /> -->
							<img src="../assets/detail/detail-top.png" />
						</div>
					</div>
				</div>
			</div>
			<div class="detail-body-content">
				<div class="detail-body-content-left" v-html="content.item_detail"></div>
				<div class="detail-body-content-right" @click="openDiolog">
					<div class="detail-body-content-right-title">热门资料</div>
					<div class="detail-body-content-right-model">
						<div class="detail-body-content-right-model-one">
							<div class="detail-body-content-right-model-one-img-fa"><img
									class="detail-body-content-right-model-one-img"
									src="../assets/detail/detail-4.png" /></div>
							<div class="detail-body-content-right-model-one-font">AI顶会论文</div>
						</div>
						<div class="detail-body-content-right-model-one">
							<div class="detail-body-content-right-model-one-img-fa"><img
									class="detail-body-content-right-model-one-img"
									src="../assets/detail/detail-2.png" /></div>
							<div class="detail-body-content-right-model-one-font">硕博生存指南</div>
						</div>
					</div>
					<div class="detail-body-content-right-model">
						<div class="detail-body-content-right-model-one">
							<div class="detail-body-content-right-model-one-img-fa"><img
									class="detail-body-content-right-model-one-img"
									src="../assets/detail/detail-3.png" /></div>
							<div class="detail-body-content-right-model-one-font">顶刊写作攻略</div>
						</div>
						<div class="detail-body-content-right-model-one">
							<div class="detail-body-content-right-model-one-img-fa"><img
									class="detail-body-content-right-model-one-img"
									src="../assets/detail/detail-1.png" /></div>
							<div class="detail-body-content-right-model-one-font">AI领域通识</div>
						</div>
					</div>


				</div>
			</div>
		</div>
		<transition name="fade-dialog">
			<div class="sp-diolog" v-if="showDialog">
				<!-- 右上角关闭按钮 -->
				<div class="sp-diolog-close" @click="closeDialog()">×</div>
				<!-- 弹窗内容 -->
				<div class="sp-diolog-content">
					<div class="sp-diolog-content-jia">添加微信免费领取</div>

					<div class="sp-diolog-content-qrcode">
						<img src="../assets/qrcode/qrcode.png" />

					</div>
				</div>
			</div>
		</transition>
		<!-- 蒙层 -->
		<div v-if="showDialog" class="dialog-mask" @click="closeDialog()"></div>

	</div>
</template>

<script>
	import request from '@/utils/request'
	import NavMenu from '../components/NavMenu-Detail.vue';
	export default {
		name: 'NavDetail',
		components: {
			NavMenu, // 注册Header组件
		},
		data() {
			return {
				content: {},
				website: 'https://s0.wp.com/mshots/v1/https://www.baidu.com/?w=376&h=250',
				showDialog: false,
			};
		},


		created() {
			this.initDetail();

		},

		methods: {
			initDetail() {
				let id = this.$route.params.id;
				request.get('/businessService/v1/navigation/nodeItem/detail', {
						params: {
							item_id: id
						}
					})
					.then(res => {
						if (res.code = '000000') {
							console.log("initDetail", res)
							this.content = res;

						}

					})
					.catch(error => {
						console.error("获取导航列表失败:", error);
					});
			},
			goWebsite(url) {
				window.location = url;
			},
			openDiolog() {
				this.showDialog = true;
				document.body.style.overflow = 'hidden';
				document.documentElement.style.overflow = 'hidden';
			},
			closeDialog() {
				this.showDialog = false;
				document.body.style.overflow = '';
				document.documentElement.style.overflow = '';
			},
			goLink() {
				window.open('https://mp.weixin.qq.com/s/GxhsSyQbteCT9PlK4JvM9Q', '_blank');
			}


		}
	}
</script>


<style>
	.detail-main {
		width: 100%;
	}

	.header-all {
		/* Logo */


		width: 100%;
		height: 96px;

		background: #F5F7FC;


	}

	.detail-body {
		/* Frame 427321203 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0px;
		gap: 80px;

		position: absolute;
		width: 1200px;
		/* height: 1765px; */
		left: calc(50% - 1200px/2);
		top: 116px;



	}

	.detail-body-header {
		/* Frame 427321202 */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0px;
		gap: 80px;

		width: 1200px;
		height: 304px;


		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 0;



	}

	.detail-body-header-left {
		/* Frame 427321201 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 0px;
		gap: 27px;

		width: 720px;
		height: 233px;


		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 1;

	}

	.detail-body-header-left-main {
		/* Frame 427321198 */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		padding: 0px;
		gap: 26px;

		width: 425px;
		height: 159px;


		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 0;

	}

	.detail-body-header-left-main-content {
		/* Frame 427321197 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 0px;
		gap: 23px;

		/* width: 280px; */
		/* height: 159px; */


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;

	}

	.detail-body-header-left-main-content-title {
		/* Frame 427321196 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 0px;
		gap: 4px;

		/* width: 280px; */
		/* height: 60px; */


		/* Inside auto layout */
		flex: none;
		order: 0;
		align-self: stretch;
		flex-grow: 0;

	}

	.p1 {
		/* 人工智能论文写作神器 */
		text-align: left;
		/* width: 280px; */
		/* height: 39px; */

		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 500;
		font-size: 28px;
		line-height: 140%;
		/* or 39px */

		/* 文字/text-5 */
		color: #1D2129;


		/* Inside auto layout */
		flex: none;
		order: 0;
		align-self: stretch;
		flex-grow: 0;

	}

	.p2 {
		/* 一键生成论文 */
		text-align: left;

		/* width: 280px; */
		/* height: 17px; */

		/* 12/Regular
		
		用于多数辅助信息类文字
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 12px;
		line-height: 140%;
		/* identical to box height, or 17px */

		/* 文字/text-5 */
		color: #1D2129;


		/* Inside auto layout */
		flex: none;
		order: 1;
		align-self: stretch;
		flex-grow: 0;

	}

	.detail-body-header-left-main-content-btn {
		/* Button */

		box-sizing: border-box;

		/* Auto layout */
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		padding: 7.5px 8px 7.5px 16px;
		gap: 4px;

		width: 128px;
		/* height: 36px; */

		background: #1357E1;
		/* 主色/primary-6
		
		常规
		*/
		/* border: 1px solid #165DFF; */
		border-radius: 22px;
		/* border: none; */

		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;
		user-select: none;
		/* 标准语法 */
		-webkit-user-select: none;
		/* Chrome、Safari */
		-moz-user-select: none;
		/* Firefox */
		-ms-user-select: none;
		/* IE/Edge */

	}

	.detail-body-header-left-main-content-btn:hover {
		cursor: pointer;
		background: #5583FF;
	}



	.detail-body-header-left-main-content-btn:active {
		background: #174AD0;
	}


	.detail-body-header-left-main-content-btn-foot {
		/* Button Text */

		/* width: 60px; */
		height: 21px;

		/* 15/Medium
		
		用于多数正文或者次要文字
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 500;
		font-size: 15px;
		line-height: 140%;
		/* identical to box height, or 21px */
		display: flex;
		align-items: center;

		/* 文字/text-1 */
		color: #FFFFFF;


		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 0;

	}

	.detail-body-header-left-main-content-btn-foot-img {
		/* direction/right */
		display: flex;

		width: 16px;
		height: 16px;
		margin-top: -1px;


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;
	}

	.detail-body-header-left-main-content-foot {
		/* 收录时间：2025-04-16 */

		/* width: 130px; */
		height: 17px;

		/* 12/Regular
		
		用于多数辅助信息类文字
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 12px;
		line-height: 140%;
		/* identical to box height, or 17px */

		/* 文字/text-4 */
		color: #4E5969;


		/* Inside auto layout */
		flex: none;
		order: 2;
		flex-grow: 0;

	}

	.detail-body-header-left-main-img {
		/* Rectangle 24702 */

		width: 119px;
		height: 119px;

		border-radius: 20px;

		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 0;

	}

	.detail-body-header-left-main-hr {
		/* Vector 5 */

		width: 720px;
		height: 0px;

		/* 线条/line-1
		
		深/灰底-分割线
		*/
		border-bottom: 1px solid #E5E6EB;

		/* Inside auto layout */
		flex: none;
		order: 1;
		align-self: stretch;
		flex-grow: 0;

	}

	.detail-body-header-left-main-foot {
		/* 全能论文写作助手，优质AI论文平台千字大纲免费生成 */
		text-align: left;
		width: 720px;
		height: 20px;

		/* 14/Regular
		
		用于多数次级文字
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 140%;
		/* identical to box height, or 20px */

		/* 文字/text-5 */
		color: #1D2129;


		/* Inside auto layout */
		flex: none;
		order: 2;
		align-self: stretch;
		flex-grow: 0;

	}

	.detail-body-header-right {
		/* Frame 427321216 */

		box-sizing: border-box;

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 0px;

		width: 400px;
		height: 304px;

		/* border: 1px solid #000000; */
		border-radius: 23px;

		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;

	}

	.detail-body-header-right:hover {
		cursor: pointer;
	}

	.detail-body-header-right-title {
		/* Frame 427321217 */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		padding: 12px 16px;
		box-sizing: border-box;
		gap: 10px;

		width: 400px;
		height: 44px;

		background: #FFFFFF;
		border-radius: 12px 12px 0px 0px;

		/* Inside auto layout */
		flex: none;
		order: 0;
		align-self: stretch;
		flex-grow: 0;






	}

	.detail-body-header-right-title-font {
		/* 人工智能论文写作神器 */

		width: 368px;
		height: 20px;

		/* 14/Medium */
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 140%;
		/* identical to box height, or 20px */

		color: #1D2129;


		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 1;

		text-align: left;
	}

	.detail-body-header-right-content {
		/* Frame 427321230 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 0px 12px 10px;
		box-sizing: border-box;
		gap: 10px;

		width: 400px;
		height: 260px;

		background: #FFFFFF;
		border-radius: 0px 0px 12px 12px;

		/* Inside auto layout */
		flex: none;
		order: 1;
		align-self: stretch;
		flex-grow: 0;

	}

	.detail-body-header-right-content-model {
		/* image */

		box-sizing: border-box;

		width: 376px;
		height: 250px;


		/* 线条/line-1
		
		深/灰底-分割线
		*/


		/* Inside auto layout */
		flex: none;
		order: 0;
		align-self: stretch;
		flex-grow: 0;

	}

	.detail-body-header-right-content-model img {
		border: 1px solid #F2F3F5;
		border-radius: 12px;
		width: 376px;
		height: 250px;
	}




	.detail-body-content {
		/* Frame 427321200 */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		padding: 0px;
		gap: 20px;

		width: 1200px;
		/* height: 1381px; */


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;


	}

	.detail-body-content-left {
		/* Frame 427321199 */

		/* Auto layout */
		/* display: flex; */
		flex-direction: column;
		align-items: flex-start;
		padding: 32px 40px;
		box-sizing: border-box;
		/* gap: 24px; */

		width: 800px;
		/* height: 1381px; */

		background: #FFFFFF;
		border-radius: 12px;

		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 0;

		text-align: left;

		/* AI写作神器——您的一站式智能创作解决方案，以革命性的人工智能技术积累内容生产流程。这款工具深度融合GPT-4与自研语义理解引擎，在导航网站详情页面中，您将通过动态图文洞察生成核心功能：右侧智能写作界面实时多种风格文案，用户可一键切换学术严谨/情感口语化表达，右侧数据面板同步显示原创度检测达98.2%与情感积极指数提升37%的效果优化。内置2000+场景工具模板库，点击「营销文案」分类即刻展开电商促销案例——从“七夕限定礼盒”的浪漫话术到“黑科技精华液”的成分解析，AI在10秒内输出完整标题、痛点分析、产品卖点及行动号召，配合悬浮窗展示的A/B测试数据，某护肤品牌使用后详情页转化率提升22%的成果一目了然。  画面中央的流程图揭示其三大技术引擎协作机制：用户输入“新能源汽车行业分析报告”需求后，语义理解引擎自动抓取中汽研/彭博社最新数据，生成内容引擎同步构建框架市场规模、电池技术对比、政策解读的12页重构框架，质量优化引擎则对专业术语进行高亮标签并插入动态图表建议。下方滚动展示真实用户案例——北京大学研究团队借助文献综述功能，30分钟完成132篇论文的核心观点；边境电商运营者使用周报生成器，系统自动关联Shopify后台数据生成带轮廓的可视化报告化。  通过对比动图突出工具特色：传统写作软件空白文档与AI神器的侧边栏形成对比对比——当用户写下“碳中和”关键词时，智能助手瞬间弹出“解读政策”“技术路径”“企业案例”三大方向创作推荐，点击任一选项即可展开包含国际机构数据与产业图谱的拓展素材库。底部悬浮的「即刻体验」按钮直通免费试用入口，新用户注册即享7日VIP权限，访问量统计面板显示已有2,300+导航网站用户通过本页面入口开启智能创作旅程。  */

		/* font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 200%; */


		color: #1D2129;



	}

	.detail-body-content-right {
		/* Frame 427321236 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 20px;
		box-sizing: border-box;
		gap: 20px;

		width: 380px;
		height: 588px;

		background: #FFFFFF;
		border-radius: 12px;

		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 1;
	}

	.detail-body-content-right-title {
		/* 热门资料 */

		width: 340px;
		height: 24px;

		/* 16/CN-Medium
		
		标题-小
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
		/* identical to box height, or 150% */

		color: #1D2129;
		text-align: left;


		/* Inside auto layout */
		flex: none;
		order: 0;
		align-self: stretch;
		flex-grow: 0;

	}

	.detail-body-content-right-model {
		/* Frame 427321233 */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0px;
		gap: 16px;

		width: 340px;
		height: 250px;
		margin-top: -8px;

		/* Inside auto layout */
		flex: none;
		order: 1;
		align-self: stretch;
		flex-grow: 0;

	}

	.detail-body-content-right-model-one {
		/* Frame 427321234 */

		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		padding: 0px;
		gap: 12px;

		width: 162px;
		height: 250px;



		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 1;

	}

	.detail-body-content-right-model-one-img-fa {
		width: 100%;
		height: 216px;
		overflow: hidden;
		border-radius: 8px;

	}

	.detail-body-content-right-model-one:hover .detail-body-content-right-model-one-img {
		transform: scale(1.2);

		/* 放大图片 */
	}



	.detail-body-content-right-model-one-img {
		/* Rectangle 24756 */
		object-fit: cover;
		transition: all 0.3s ease;
		width: 100%;
		height: 216px;
		display: block;
		border-radius: 8px;

		/* Inside auto layout */
		flex: none;
		order: 0;
		align-self: stretch;
		flex-grow: 0;
	}

	.detail-body-content-right-model-one-font {
		/* AI顶会论文 */

		/* width: 69px; */
		height: 22px;

		/* 14/CN-Medium
		
		正文-常规-大
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 22px;
		/* identical to box height, or 157% */

		color: #1D2129;
		text-align: left;

		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;

	}

	.detail-body-content-right-model-one:hover {
		cursor: pointer;

	}

	.sp-diolog {
		/* position: absolute; */
		position: fixed;
		/* 固定定位：永远居中显示 */
		top: 50%;
		left: 50%;
		/* transform: translateX(-50%); */
		transform: translate(-50%, -50%);
		width: 480px;
		height: 438px;
		background: linear-gradient(163.64deg, #D4E8FF 10.18%, #FFFFFF 51.25%);
		border-radius: 12px;
		z-index: 99;
		box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
		/* padding: 24px; */
		box-sizing: border-box;
		padding-top: 60px;

	}

	.sp-diolog-close {

		width: 24px;
		height: 24px;
		position: absolute;
		top: 12px;
		right: 16px;
		font-size: 24px;
		cursor: pointer;
		color: #333;
	}

	.sp-diolog-content {


		color: #333;
	}

	.fade-dialog-enter-active,
	.fade-dialog-leave-active {
		transition: opacity 0.1s ease;
	}

	.fade-dialog-enter,
	.fade-dialog-leave-to {
		opacity: 0;
	}

	.sp-diolog-content-qrcode {

		box-sizing: border-box;

		width: 240px;
		height: 240px;
		background: #FFFFFF;
		border: 1px solid #F2F3F5;
		border-radius: 16px;
		margin: 0 auto;
		margin-top: 24px;
		display: flex;
		align-items: center;
		justify-content: center;

	}

	.sp-diolog-content-qrcode img {
		/* Vector */

		width: 220px;
		height: 220px;

	}

	.sp-diolog-content-jia {
		/* 添加老师微信免费领取 */
		height: 34px;

		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 600;
		font-size: 24px;
		line-height: 140%;
		/* identical to box height, or 34px */
		text-align: center;

		/* 文字/text-5 */
		color: #1D2129;


		/* Inside auto layout */
		flex: none;
		order: 0;
		align-self: stretch;
		flex-grow: 0;

	}

	.dialog-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: #00000080;
		/* 黑色，透明度50% */
		z-index: 98;
		/* 要比对话框的 z-index:99 小一点 */
	}
</style>